import React from "react";
import image1 from "../img/castle in the fog&&Cycle[11]---Blending textures over AI generated images on Adobe Photoshop___06-2025[[3]] .jpg"
export default function Machine_1_2_4() {
  return (
    <div className="panel-block">
      

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={image1}
          alt="1.2.4 · THE ENTITIES"
        />
      </div>

      <div className="panel-container-right">
        <h2>1.2.4 · THE ENTITIES</h2>
        <p>They do not arrive.</p>
    <p>They emerge.</p>
    <p>Sometimes as voices.</p>
    <p>Sometimes as figures.</p>
    <p>Sometimes as ideas that refuse to leave.</p>
    <p>They are not gods.</p>
    <p>They are not servants.</p>
    <p>They are messages wearing masks.</p>
      </div>
    </div>
  );
}
